import 'react';
import '@backstage/version-bridge';
import '@backstage/errors';
import { createApiRef } from '../system/ApiRef.esm.js';

const configApiRef = createApiRef({
  id: "core.config"
});

export { configApiRef };
//# sourceMappingURL=ConfigApi.esm.js.map
